window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Mixins ??= {};

AppointmentBooking.Wizard.Views.Mixins.OAuthLink = (superclass) =>
  (() => {
    const Cls = class extends superclass {
      constructor() {
        super(...arguments);
        this.openOAuthWindow = this.openOAuthWindow.bind(this);
      }

      // EVENT HANDLERS

      openOAuthWindow() {
        const oauthUrl = AppointmentBooking.config.oauth_url;
        this.assert.presence(oauthUrl, "Error authorizing MyChart login. No Oauth url was configured.");

        this.model.set("mychart_login_error", null);

        return window.open(oauthUrl, "SparkleEpicOAuthWindow", "scrollbars=1,resizable=1,height=600,width=700");
      }
    };
    Cls.prototype.events = { "click [data-behaviour=mychart-oauth]": "openOAuthWindow" };
    return Cls;
  })();
